import { render, staticRenderFns } from "./fcwpArchiveCard.vue?vue&type=template&id=0c18c9b5&"
import script from "./fcwpArchiveCard.vue?vue&type=script&lang=js&"
export * from "./fcwpArchiveCard.vue?vue&type=script&lang=js&"
import style0 from "./fcwpArchiveCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports